import { useState } from "react";
import { Box, Button, Paper, Typography } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import QrCode2Icon from "@mui/icons-material/QrCode2";
import { Link } from "react-router-dom";
import { useMenuIdFromURL } from "../../../hooks/menuIdFromURL";

export const GoLiveSuccess = () => {
  const menuId = useMenuIdFromURL();
  const menuUrl = `${window.location.origin}/menu/${menuId}`;
  const qrPath = `/dashboard/menu/${menuId}/qr-generation`;
  const [copied, setCopied] = useState(false);

  const copyMenuUrl = () => {
    navigator.clipboard.writeText(menuUrl).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <Paper elevation={2} sx={{ mb: 2, overflow: "hidden", borderRadius: 2 }}>
      <Box
        sx={{
          bgcolor: "success.main",
          px: 3,
          py: 2,
          color: "white",
          display: "flex",
          alignItems: "center",
          gap: 1.5,
        }}
      >
        <CheckCircleIcon sx={{ fontSize: 28, flexShrink: 0 }} />
        <Box>
          <Typography fontWeight={700} fontSize="16px">
            Your menu is live!
          </Typography>
          <Typography variant="body2" sx={{ opacity: 0.85 }}>
            Customers can scan your QR and place orders
          </Typography>
        </Box>
      </Box>

      <Box px={2.5} py={2}>
        <Typography
          variant="caption"
          color="text.secondary"
          display="block"
          mb={0.5}
        >
          Your menu link
        </Typography>
        <Box display="flex" alignItems="center" gap={1} mb={2}>
          <Box
            sx={{
              flex: 1,
              bgcolor: "rgba(0,0,0,0.04)",
              borderRadius: 1,
              px: 1.5,
              py: 0.75,
              overflow: "hidden",
            }}
          >
            <Typography variant="body2" noWrap color="text.secondary">
              {menuUrl}
            </Typography>
          </Box>
          <Button size="small" variant="outlined" onClick={copyMenuUrl}>
            {copied ? "Copied!" : "Copy"}
          </Button>
        </Box>

        <Box display="flex" gap={1} flexWrap="wrap">
          <Button
            size="small"
            variant="contained"
            component={Link}
            to={`/menu/${menuId}?t=Test+Table`}
          >
            Place a test order
          </Button>
          <Button
            size="small"
            variant="outlined"
            component={Link}
            to={qrPath}
            startIcon={<QrCode2Icon />}
          >
            Get QR codes
          </Button>
        </Box>
      </Box>
    </Paper>
  );
};
